<div class="home-container" [class.dashboard-mode]="hasEvents">
  <app-load-error *ngIf="eventsError" (retry)="loadEvents()"></app-load-error>
  <!-- ============================================================= -->
  <!-- DASHBOARD — utenti con eventi                                  -->
  <!-- ============================================================= -->
  <ng-container *ngIf="hasEvents">
    <div class="dash">
      <header class="dash-header desktop-only">
        <h1 class="dash-greeting">
          {{ "home.dashboard.hello" | translate }}<span *ngIf="userName"> {{ userName }}</span>
        </h1>
        <p class="dash-sub">{{ "home.dashboard.overview" | translate }}</p>
      </header>

      <div class="mobile-top mobile-only">
        <header>
          <p class="mobile-greeting">
            {{ "home.dashboard.hello" | translate }}<span *ngIf="userName"> {{ userName }}</span>,
          </p>
          <p class="mobile-sub">{{ "home.dashboard.overview" | translate }}</p>
        </header>
        <div class="mobile-quick-actions">
          <a routerLink="/eventi/nuovo" class="quick-action quick-action-primary">
            <span class="quick-action-icon"><app-icon name="plus" [size]="20" /></span>
            <span>{{ "home.create_event" | translate }}</span>
          </a>
          <a routerLink="/calendario" class="quick-action quick-action-accent">
            <span class="quick-action-icon"><app-icon name="calendar" [size]="20" /></span>
            <span>{{ "navbar.calendar" | translate }}</span>
          </a>
          <a routerLink="/eventi" class="quick-action">
            <span class="quick-action-icon"><app-icon name="rings" [size]="20" /></span>
            <span>{{ "navbar.wedding" | translate }}</span>
          </a>
          <a routerLink="/contratti" class="quick-action quick-action-accent">
            <span class="quick-action-icon"><app-icon name="file" [size]="20" /></span>
            <span>{{ "navbar.contracts" | translate }}</span>
          </a>
        </div>
      </div>

      <!-- IN PRIMO PIANO -->
      <div class="dash-band">
        <h2 class="band-title">{{ "home.dashboard.band_present" | translate }}</h2>
        <div class="dash-grid dash-grid-even">
          <article class="panel next-panel">
            <header class="panel-head">
              <span class="panel-title">{{ "home.next_wedding" | translate }}</span>
            </header>

            <button class="next-main" *ngIf="nextWedding; else noNext" (click)="goto('wedding')">
              <span class="date-block">
                <span class="date-day">{{ dayOf(nextWedding.event.date) }}</span>
                <span class="date-month">{{ monthOf(nextWedding.event.date) }}</span>
              </span>
              <span class="next-info">
                <span class="next-name">{{ nextWedding.client.name }} {{ nextWedding.client.lastname }}</span>
                <span class="next-meta">
                  <span *ngIf="nextWedding.event.time">{{ "home.dashboard.at_time" | translate: { time: nextWedding.event.time } }}</span>
                  <span *ngIf="nextWedding.event.location"><app-icon name="pin" [size]="13" /> {{ nextWedding.event.location }}</span>
                  <em *ngIf="nextTravelKm > 0">{{ nextTravelKm }} km A/R</em>
                </span>
                <span class="next-tags" *ngIf="getServices(nextWedding).length">
                  <span *ngFor="let tag of getServices(nextWedding)">{{ tag }}</span>
                </span>
              </span>
              <span class="countdown" *ngIf="nextDays !== null">{{ countdownKey | translate: { n: nextDays } }}</span>
            </button>
            <ng-template #noNext>
              <div class="panel-empty">
                <app-icon name="calendar-heart" [size]="20" />
                <span>{{ "home.no_wedding" | translate }}</span>
                <a routerLink="/eventi/nuovo" class="see-all">+ {{ "home.dashboard.new_event" | translate }}</a>
              </div>
            </ng-template>

            <button class="panel-foot" [disabled]="!nextTrial" (click)="openTrial()">
              <span class="foot-icon"><app-icon name="scissors" [size]="15" /></span>
              <span class="foot-label">{{ trialTitleKey | translate }}</span>
              <span class="foot-value" *ngIf="nextTrial">
                {{ nextTrial.client.name }} {{ nextTrial.client.lastname }} · {{ formatDateShort(nextTrial.event.test_date) }}
              </span>
              <span class="foot-value foot-muted" *ngIf="!nextTrial">{{ "home.dashboard.no_trial" | translate }}</span>
            </button>
          </article>

          <article class="panel">
            <header class="panel-head">
              <span class="panel-title">{{ "home.dashboard.watch_title" | translate }}</span>
              <a routerLink="/calendario" class="see-all">{{ "navbar.calendar" | translate }} →</a>
            </header>
            <ul class="panel-list" *ngIf="reminders.length || deadlines.length; else noWatch">
              <li class="row" *ngFor="let r of reminders">
                <span class="row-icon"><app-icon name="bell" [size]="15" /></span>
                <span class="row-text">{{ r.text }}</span>
              </li>
              <li *ngFor="let d of deadlines">
                <button class="row row-link" (click)="openEvent(d.id)">
                  <span class="row-icon row-icon-alert"><app-icon [name]="d.kind === 'quote' ? 'note' : 'sign'" [size]="15" /></span>
                  <span class="row-text">
                    <b>{{ d.name }}</b>
                    <em>{{ deadlineKey(d) | translate: { date: formatDateShort(d.date) } }}</em>
                  </span>
                  <span class="row-arrow">→</span>
                </button>
              </li>
            </ul>
            <ng-template #noWatch>
              <div class="panel-empty">
                <app-icon name="check" [size]="20" />
                <span>{{ "home.dashboard.watch_empty" | translate: { days: deadlineDays } }}</span>
              </div>
            </ng-template>
          </article>
        </div>
      </div>

      <!-- IN ARRIVO -->
      <div class="dash-band">
        <h2 class="band-title">{{ "home.dashboard.band_future" | translate }}</h2>

        <section class="dash-stats">
          <button class="stat-card stat-events" (click)="goto('/eventi')">
            <span class="stat-icon"><app-icon name="calendar" [size]="18" /></span>
            <span class="stat-value">{{ countUpcoming }}</span>
            <span class="stat-label">{{ "home.dashboard.upcoming" | translate }}</span>
          </button>
          <button class="stat-card stat-quote" (click)="goto('/eventi?stato=preventivo')">
            <span class="stat-icon"><app-icon name="send" [size]="18" /></span>
            <span class="stat-value">{{ countQuotesSent }}</span>
            <span class="stat-label">{{ "home.dashboard.quotes_sent" | translate }}</span>
          </button>
          <button class="stat-card stat-todo" (click)="goto('/eventi')">
            <span class="stat-icon"><app-icon name="file" [size]="18" /></span>
            <span class="stat-value">{{ countToGenerate }}</span>
            <span class="stat-label">{{ "home.dashboard.to_generate" | translate }}</span>
          </button>
          <button class="stat-card stat-money" (click)="goto('/eventi')">
            <span class="stat-icon"><app-icon name="euro" [size]="18" /></span>
            <span class="stat-value">{{ formatCurrency(openBalance) }}</span>
            <span class="stat-label">{{ "home.dashboard.open_balance" | translate }}</span>
          </button>
        </section>

        <div class="dash-grid">
          <article class="panel" *ngIf="agenda.length > 1">
            <header class="panel-head">
              <span class="panel-title">{{ "home.dashboard.agenda" | translate }}</span>
              <a routerLink="/eventi" class="see-all">{{ "home.dashboard.see_all" | translate }} →</a>
            </header>
            <ul class="panel-list">
              <li *ngFor="let m of agenda">
                <button class="row row-link" (click)="openEvent(m._id)">
                  <span class="agenda-date">{{ formatDateShort(m.event.date) }}</span>
                  <span class="row-text row-ellipsis">{{ m.client.name }} {{ m.client.lastname }}</span>
                  <span class="agenda-badge" [ngClass]="m._status.cls">
                    <app-icon [name]="m._status.icon" [size]="13" /> {{ m._status.key | translate }}
                  </span>
                </button>
              </li>
            </ul>
          </article>

          <article class="panel">
            <header class="panel-head">
              <span class="panel-title">{{ "home.dashboard.todo" | translate }}</span>
            </header>
            <ul class="panel-list" *ngIf="todos.length > 0; else allDone">
              <li *ngFor="let t of todos">
                <button class="row row-link" (click)="goto(t.link)">
                  <span class="row-icon"><app-icon [name]="t.icon" [size]="15" /></span>
                  <span class="row-text">
                    <span><b>{{ t.count }}</b> {{ t.textKey | translate }}</span>
                    <em *ngIf="t.amount > 0">{{ formatCurrency(t.amount) }}</em>
                  </span>
                  <span class="row-arrow">→</span>
                </button>
              </li>
            </ul>
            <ng-template #allDone>
              <div class="panel-empty">
                <app-icon name="check" [size]="20" />
                <span>{{ "home.dashboard.all_done" | translate }}</span>
              </div>
            </ng-template>
          </article>
        </div>
      </div>

      <!-- IL TUO PERCORSO -->
      <div class="dash-band">
        <h2 class="band-title">{{ "home.dashboard.band_past" | translate }}</h2>
        <div class="panel summary">
          <div class="summary-item">
            <span class="summary-value">{{ statEventsDone }}</span>
            <span class="summary-label">
              {{ "home.dashboard.events_done" | translate }}
              <app-info-tooltip [text]="'home.dashboard.events_done_tooltip' | translate"></app-info-tooltip>
            </span>
          </div>
          <div class="summary-item">
            <span class="summary-value">{{ statSigned }}</span>
            <span class="summary-label">
              {{ "home.dashboard.signed" | translate }}
              <app-info-tooltip [text]="'home.dashboard.signed_tooltip' | translate"></app-info-tooltip>
            </span>
          </div>
          <div class="summary-item">
            <span class="summary-value">{{ formatCurrency(statCollected) }}</span>
            <span class="summary-label">
              {{ "home.dashboard.collected" | translate }}
              <app-info-tooltip [text]="'home.dashboard.collected_tooltip' | translate" position="left"></app-info-tooltip>
            </span>
          </div>
        </div>
      </div>

      <!-- TEASER PRO -->
      <article class="panel pro-teaser" *ngIf="!canProStats">
        <span class="pro-teaser-icon"><app-icon name="chart" [size]="18" /></span>
        <div class="pro-teaser-text">
          <b>{{ "home.dashboard.pro_teaser_title" | translate }}</b>
          <span [innerHTML]="'home.dashboard.pro_teaser_text' | translate"></span>
        </div>
        <button class="pro-teaser-btn" (click)="goToPlans()">{{ "home.dashboard.pro_teaser_cta" | translate }}</button>
      </article>

      <!-- TRASFERTE -->
      <div class="dash-band" *ngIf="canProStats && (statKmYear > 0 || statKmUpcoming > 0 || statTravelCostYear > 0)">
        <h2 class="band-title band-title-sm"><app-icon name="car" [size]="18" /> {{ "home.dashboard.travel_title" | translate }}</h2>
        <div class="panel summary">
          <div class="summary-item">
            <span class="summary-value">{{ statKmYear | number: "1.0-0" }} km</span>
            <span class="summary-label">{{ "home.dashboard.km_year" | translate: { year: currentYear } }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-value">{{ statKmUpcoming | number: "1.0-0" }} km</span>
            <span class="summary-label">{{ "home.dashboard.km_upcoming" | translate }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-value">{{ formatCurrency(statTravelCostYear) }}</span>
            <span class="summary-label">{{ "home.dashboard.travel_cost_year" | translate }}</span>
          </div>
        </div>
      </div>

      <!-- MAPPA DEL MESE (solo desktop) -->
      <div class="dash-band dash-map" *ngIf="canProStats && monthEvents.length && isDesktopViewport">
        <h2 class="band-title band-title-sm"><app-icon name="map" [size]="18" /> {{ "home.dashboard.month_map" | translate }}</h2>
        <app-events-map [events]="monthEvents"></app-events-map>
      </div>
    </div>
  </ng-container>

  <!-- ============================================================= -->
  <!-- HERO — utenti senza eventi (primo accesso)                     -->
  <!-- ============================================================= -->
  <ng-container *ngIf="!hasEvents && !eventsError">
    <section class="hero">
      <div class="hero-text">
        <img src="nyzed-brand-logo.png" alt="Nyzed" class="hero-logo" />
        <p class="hero-eyebrow">{{ "home.eyebrow" | translate }}</p>
        <h1 class="hero-title">
          {{ "home.hero_title_1" | translate }}<br />
          <em>{{ "home.hero_title_2" | translate }}</em>
        </h1>
        <p class="hero-subtitle">
          <b>NYZED</b> {{ "home.hero_subtitle" | translate }}
        </p>
        <a id="tour-crea-evento" (click)="onCtaClick()" class="cta-button">{{
          (profileCompleted ? "home.create_event" : "home.go") | translate
        }}</a>
      </div>
      <div class="hero-visual">
        <div class="hero-card hero-card-empty">
          <span class="hero-card-label">{{ "home.no_wedding" | translate }}</span>
          <a
            routerLink="/eventi/nuovo"
            class="cta-button"
            style="margin-top: 1rem"
            >{{ "home.add" | translate }}</a
          >
        </div>
      </div>
    </section>

    <div class="section-divider">
      <span>———</span>
      <span class="divider-dot">✦</span>
      <span>———</span>
    </div>

    <section class="features">
      <div class="feature-card" (click)="goto('/contratti')">
        <div class="feature-icon"><app-icon name="file" [size]="28" /></div>
        <h3>{{ "home.features.contracts_title" | translate }}</h3>
        <p>{{ "home.features.contracts_desc" | translate }}</p>
      </div>
      <div class="feature-card" (click)="goto('/calendario')">
        <div class="feature-icon"><app-icon name="calendar" [size]="28" /></div>
        <h3>{{ "home.features.calendar_title" | translate }}</h3>
        <p>{{ "home.features.calendar_desc" | translate }}</p>
      </div>
      <div class="feature-card" (click)="goto('/eventi')">
        <div class="feature-icon"><app-icon name="rings" [size]="28" /></div>
        <h3>{{ "home.features.clients_title" | translate }}</h3>
        <p>{{ "home.features.clients_desc" | translate }}</p>
      </div>
    </section>
  </ng-container>
</div>
